import React, { useState } from "react";
import "./PaywallPopup.css";
import { RiCheckboxCircleFill } from "react-icons/ri";
import ContentDiv from "./ContentDiv";
import { loadStripe } from "@stripe/stripe-js";
import { publickey } from "../../Constants";

const ModalBody = ({id}) => {
  const stripepromise = loadStripe(publickey);

  const [loading, setloading] = useState();

  const sData = [
    { title: "UNLIMITED articles" },
    { title: "1500+ words per article" },
    { title: "10 day trial + 10% off" },
    { title: "Double your content output" },
    { title: "SEO and reader friendly " },
    { title: "Keyword and Topic analysis" },
    { title: "Instant content in seconds" },
    { title: "1000’s more in traffic per month" },
    { title: "Easily cancel anytime" },
    { title: "One time offer price (going up!)" },
  ];
  const getClientReferenceId = ()=> {
    console.log('refeell', window.Rewardful && window.Rewardful.referral )
    return window.Rewardful && window.Rewardful.referral || ('checkout_'+(new Date).getTime());
  }
  const handlepayment = async () => {
    setloading(true);
    const stripe = await stripepromise;

    const { error } = await stripe.redirectToCheckout({
      lineItems: [
        {
          price: "price_1LFfoiL3l7aU5iEtObQRrr8p",
          quantity: 1,
        },
      ],
      mode: "subscription",
      cancelUrl: `${window.location.origin}/cancel`,
      successUrl: `${window.location.origin}/success/${id}`,
      clientReferenceId: getClientReferenceId()
    });

    if (error) {
      setloading(false);
      console.log(error);
    }
  };

  return (
    <div className="modal-body-wrapper">
      <div className="content-wrapper">
        <ContentDiv />
      </div>
      <div className="button-wrapper">
        <h1>START MY FREE TRIAL👇🏻</h1>
        <p id="tenday">10 DAY FREE TRIAL WITH UNLIMITED BLOG POSTS!</p>

        <p className="content-text-div">
          10 days free trial then pay just £29.99 a month for unlimited blog
          posts. Cancel anytime in the 10 days and you’re not charged - no
          questions asked. We’ll even email you the day before your trial ends.
          <u>
            <b>
              You’re guaranteed your refund
            </b>
          </u>{" "}
          (
          <i style={{ fontFamily: "sans-serif" }}>
            even if you’re a few days late!
          </i>
          )
        </p>
        <div className="check-div">
          {sData.map((val, index) => {
            return (
              <p className="data-list" key={index}>
                {" "}
                <RiCheckboxCircleFill
                  size={24}
                  style={{ marginRight: "10px" }}
                />{" "}
                {val.title}
              </p>
            );
          })}
        </div>
        <div className="trail-div">
          <button
            onClick={handlepayment}
            className="modal-btn"
            disabled={loading}
          >
            {/* <a href="https://buy.stripe.com/7sIeWS3Az0xV8mI9AB" target={"_blank"}>START MY FREE TRIAL!</a> */}
            START MY FREE TRIAL! <span id="promo"> + Promo code: 10OFF</span>
          </button>
          {/* <div className="checkout-btn">
            <Checkout />
          </div> */}

          <p id="buttontrail">
            50+ Other content marketers recently signed up this week!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ModalBody;
